import { defineStore } from 'pinia';
import { useModalStore } from './ModalStore';
import gsap from 'gsap';
import ApiService from '@/services/ApiService';
import { useDealerStore } from './DealerStore';

export const useTerritoryStore = defineStore('territory', {
  state () {
    return {
      dealers: null,
      dealerTerritories: null,
      isSuccessful: false,
      isMode: 'default',
      submitTerritoryName: null,
      inputType: null,
      mode: 'add',
      selectedTerritory: null,
      currentTerritory: null,
      incomplete: [],
      isWarning: false,
      tmpStates: [],
      territoryInputs: [
        // {
        //   field: 'territory',
        //   label: 'Territory*',
        //   placeholder: 'Territory',
        //   value: '',
        //   type: 'select',
        //   required: true,
        // },
        {
          field: 'manager',
          label: 'Manager Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'States',
          placeholder: 'States',
          value: [],
          type: 'select-multi',
          required: false,
        },
        {
          field: 'managerPhone',
          label: 'Work Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managerMobilePhone',
          label: 'Mobile Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managerEmail',
          label: 'Email*',
          value: '',
          placeholder: '',
          type: 'email',
          required: true,
        },
        {
          field: 'managerSkype',
          label: 'Skype',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'managerWhatsApp',
          label: 'WhatsApp',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'regions',
          label: 'Region*',
          placeholder: 'Region',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'territory',
          label: 'Territory Display',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
      ],
      territoryAddInputs: [
        // {
        //   field: 'territory',
        //   label: 'Territory*',
        //   placeholder: 'Territory',
        //   value: '',
        //   type: 'select',
        //   required: true,
        // },
        {
          field: 'manager',
          label: 'Manager Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'States',
          placeholder: 'States',
          value: [],
          type: 'select-multi',
          required: false,
        },
        {
          field: 'managerPhone',
          label: 'Work Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managerMobilePhone',
          label: 'Mobile Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managerEmail',
          label: 'Email*',
          value: '',
          placeholder: '',
          type: 'email',
          required: true,
        },
        {
          field: 'managerSkype',
          label: 'Skype',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'managerWhatsApp',
          label: 'WhatsApp',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'regions',
          label: 'Region*',
          placeholder: 'Region',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'territoryDisplay',
          label: 'Territory Display',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        // {
        //   field: 'territoryLevel',
        //   label: 'Territory Level*',
        //   placeholder: 'Dealer Level',
        //   value: {
        //     id: 1,
        //     name: 'None',
        //   },
        //   type: 'select',
        //   required: true,
        // },
      ],
      territoryBlankAddInputs: [
        // {
        //   field: 'territory',
        //   label: 'Territory*',
        //   placeholder: 'Territory',
        //   value: '',
        //   type: 'select',
        //   required: true,
        // },
        {
          field: 'manager',
          label: 'Manager Name*',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        {
          field: 'state',
          label: 'States',
          placeholder: 'States',
          value: [],
          type: 'select-multi',
          required: false,
        },
        {
          field: 'managerPhone',
          label: 'Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managerMobilePhone',
          label: 'Mobile Phone',
          value: '',
          placeholder: '',
          type: 'tel',
          required: false,
        },
        {
          field: 'managermail',
          label: 'Manager Email*',
          value: '',
          placeholder: '',
          type: 'email',
          required: true,
        },
        {
          field: 'managerSkype',
          label: 'Skype',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'managerWhatsApp',
          label: 'WhatsApp',
          value: '',
          placeholder: '',
          type: 'text',
          required: false,
        },
        {
          field: 'regions',
          label: 'Region*',
          placeholder: 'Region',
          value: '',
          type: 'select',
          required: true,
        },
        {
          field: 'territoryDisplay',
          label: 'Territory Display',
          value: '',
          placeholder: '',
          type: 'text',
          required: true,
        },
        // {
        //   field: 'url',
        //   label: 'URL',
        //   value: '',
        //   placeholder: '',
        //   type: 'text',
        //   required: false,
        // },
        // {
        //   field: 'territoryLevel',
        //   label: 'Territory Level*',
        //   placeholder: 'Territory Level',
        //   value: {
        //     id: 1,
        //     name: 'None',
        //   },
        //   type: 'select',
        //   required: true,
        // },
      ],
      territoryTableHeaders: [
        { id: '1', value: 'active', title: 'ACTIVE' },
        { id: '2', value: 'manager', title: 'NAME' },
        { id: '3', value: 'managerEmail', title: 'EMAIL' },
        { id: '4', value: 'managerPhone', title: 'PHONE' },
        { id: '5', value: 'managerMobilePhone', title: 'MOBILE PHONE' },
        { id: '6', value: 'managerSkype', title: 'SKYPE' },
        { id: '7', value: 'managerWhatsApp', title: 'WhatsApp' },
      ],
      territories: [],
      states: null,
      regions: null,
    };
  },
  getters: {
    Mode () {
      return this.mode;
    },
    SelectedTerritory () {
      return this.selectedTerritory;
    },
    CreateTerritoryInputs () {
      return this.territoryAddInputs;
    },
    EditTerritoryInputs () {
      return this.territoryInputs;
    }
  },
  actions: {
    setMode (mode) {
      this.mode = mode;
    },
    setSelectedTerritory (territory) {
      this.selectedTerritory = territory;
    },
    async fetchRegions () {
      await ApiService.getRegions('1')
      .then((response) => {
        this.regions = response.data;
      });
    },
    // async fetchTerritories () {
    //   await ApiService.getDealers().then((response) => {
    //     this.dealers = response.data;
    //     this.dealers = this.dealers.map((item) => {
    //       item.name = this.camelCaseToWords(item.name);
    //       item.address = this.camelCaseToWords(item.address);
    //       item.city = this.camelCaseToWords(item.city);
    //       return item;
    //     });
    //   });
    //   await ApiService.getDealerTerritories().then((response) => {
    //     this.dealerTerritories = response.data;
    //     item.name = this.camelCaseToWords(item.name);
    //   });
    // },
    async removeTerritory (territoryId) {
      gsap.to('#territory-row-' + territoryId, {
        backgroundColor: '#FFFFFF'
      });
      await ApiService.deleteTerritory(territoryId).then(() => {
        ApiService.getDealerTerritories().then((response) => {
          this.territories = response.data;
          this.territories = this.territories.sort((a, b) => a.sortorder - b.sortorder);
          // this.territories = this.territories.map((item) => {
          //   item.name = this.camelCaseToWords(item.name);
          //   return item;
          // });
          this.mode = 'add';
          useModalStore().hideModal();
        });
      });
    },
    async submitActiveStatus (item) {
      item.isActive = item.isActive === true ? true : false;
      const payload = item;
      await ApiService.postTerritory(payload).then(() => {
        ApiService.getDealerTerritories()
        .then((response) => {
          this.territories = response.data;
          this.territories = this.territories.sort((a, b) => a.sortorder - b.sortorder);
        });
      });
    },
    toCamelCase (str) {
      return str
        .toLowerCase()
        .replace(/[^a-zA-Z0-9]+(.)/g, (match, chr) => chr.toUpperCase());
    },
    camelCaseToWords (str) {
      const result = str.replace(/([A-Z])/g, ' $1');
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
    async submitTerritory ()
    {
      const inputs = this.mode === 'edit' ? this.territoryInputs : this.territoryAddInputs;
      var payload = {};
      inputs.forEach((item) => {
        if (item.field === 'region') {
          if (item.value.length === 0) {
            this.incomplete.push('region');
          } 
          payload.region = item.value.region;
        } else {
          if (item.value.length === 0 && item.required) {
            this.incomplete.push(item.label);
          }
          if (item.field === 'name') {
            payload[item.field] = this.toCamelCase(item.value);
          } else {
            payload[item.field] = item.value;
          }
        }
      });
      payload.territoryId = this.mode === 'edit' ? this.currentTerritory.territoryId : 0;
      if (this.incomplete.length > 0) {
        this.isWarning = true;
      } else {
        let formatStates = [];
        if (payload.state.length > 0) {
          payload.state.forEach((item) => {
            formatStates.push(item.abbreviation);
          });
        }
        const formatPayload = {
          territoryId: payload.territoryId,
          regionId: payload.regions.id,
          manager: payload.manager,
          managerPhone: payload.managerPhone,
          managerMobilePhone: payload.managerMobilePhone,
          managerEmail: payload.managerEmail,
          managerSkype: payload.managerSkype,
          managerWhatsApp: payload.managerWhatsApp,
          territory: payload.territoryDisplay,
          states: formatStates

        };
        formatPayload.isActive = this.mode === 'edit' ? this.currentTerritory.isActive : false;
        await ApiService.postTerritory(formatPayload).then((response) => {
          if (this.mode === 'edit') {
            gsap.to('#territory-row-' + payload.territoryId, {
              backgroundColor: '#FFFFFF'
            });
            this.territoryInputs = this.territoryInputs.map((item) => {
              if (item.field === 'state') {
                item.value = [];
              } else {
                item.value  = '';
              }
              return item;
            });
          } else {
              this.territoryAddInputs = this.territoryAddInputs.map((item) => {
              if (item.field === 'state') {
                item.value = [];
              } else {
                item.value  = '';
              }
              return item;
            });
          }
          // refresh dealers
          this.isSuccessful = true;
          this.isMode = this.mode;
          this.submitTerritoryName = response.data.manager;
          if (this.mode === 'add') {
            this.isMode = 'added';
          } else if (this.mode === 'edit') {
            this.isMode = 'changed';
          }
          this.mode = 'add';
          this.tmpStates = useDealerStore().states;
        ApiService.getDealerTerritories()
          .then((response) => {
            this.territories = response.data;
            this.territories = this.territories.sort((a, b) => a.sortorder - b.sortorder);
            // this.territories = this.territories.map((item) => {
            //   item.name = this.camelCaseToWords(item.name);
            //   return item;
            // });
          });
        })
        .catch((error) => {
          console.log(error);
        });
      }
      // useModalStore().hideModal()
    }
  },
});
